var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-celmode-editor-tab "},[_c('AchievementsPanel',{attrs:{"secret":false}}),_c('AchievementsPanel',{attrs:{"secret":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }